import { Component, computed, effect, input, model, output } from '@angular/core';
import { LanguageDto, SupportedLanguage } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '../../../edit-wrapper/form-edit-wrapper.component';
import { AuraInternationalizationLanguageDisplayComponent } from '../display/internationalization-language-display.component';
import { AuraInternationalizationLanguageFormComponent } from '../form/internationalization-language.form.component';

@Component({
  selector: 'aura-internationalization-language-edit',
  imports: [
    AuraEditWrapperComponent,
    AuraInternationalizationLanguageFormComponent,
    AuraInternationalizationLanguageDisplayComponent,
  ],
  templateUrl: './internationalization-language-edit.component.html',
})
export class AuraInternationalizationLanguageEditComponent {
  initialLanguage = input.required<SupportedLanguage>();
  closeEditing = input<boolean>(false);
  isEditing = model<boolean>(false);
  saved = output<LanguageDto>();

  currentLanguage = computed<LanguageDto | null>(() => {
    const language = this.initialLanguage();
    return language ? { language } : null;
  });

  constructor() {
    effect(() => {
      if (this.closeEditing()) {
        this.isEditing.set(false);
      }
    });
  }
}
